/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Phone_InvalidInputs */

const en_clients_validation_phone_invalid = /** @type {(inputs: Clients_Validation_Phone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid Brazilian phone number (e.g. +55 (11) 99999-9999).`)
};

const pt_br2_clients_validation_phone_invalid = /** @type {(inputs: Clients_Validation_Phone_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um telefone brasileiro válido (ex: +55 (11) 99999-9999).`)
};

/**
* | output |
* | --- |
* | "Enter a valid Brazilian phone number (e.g. +55 (11) 99999-9999)." |
*
* @param {Clients_Validation_Phone_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_phone_invalid = /** @type {((inputs?: Clients_Validation_Phone_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Phone_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_phone_invalid(inputs)
	return pt_br2_clients_validation_phone_invalid(inputs)
});